<div class="admin-map-wrapper" [ngClass]="{ 'has-min-height': hasMinHeight() }">
  <div class="map-container">
    <bm-base-map
      [mapPositions]="internalMapPositions()"
      [shouldResetMapZoom]="shouldResetMapZoom()"
      [loading]="isLoading()"
      [userPreferences]="userPreferences()"
      [isVirtualFenceEnabled]="isVirtualFenceEnabled()"
      [isViewOnlyMode]="isViewOnlyMode()"
      [isAnimationPlayActive]="isAnimationPlayActive()"
      [speciesMap]="speciesMap()"
    ></bm-base-map>
  </div>

  @if (!hideSidebars() && !isLoading()) {
    <div>
      @if (isVirtualFenceEnabled()) {
        <vectronic-left-sidebar
          class="virtual-fence-sidebar"
          [title]="'Virtual Fences'"
          (sidebarToggle)="mapService.onLeftSidebarToggle($event)"
        >
          <div class="vf-left-sidebar-container">
            <div class="px-6 pb-6">
              @if (showOverrideWarning()) {
                <vectronic-alert type="warning">
                  Overwrite Warning: This will replace your current Virtual Fence Rule. Changes are
                  not additive.
                </vectronic-alert>
              }
              <div
                [ngClass]="{
                  'vf-left-sidebar-filled': isVirtualFenceFilled() && !readonlyVirtualFence(),
                }"
                class="px-6"
              >
                @if (!readonlyVirtualFence()) {
                  @if (isVirtualFenceFilled()) {
                    <div class="vf-left-sidebar-button-container">
                      <button
                        mat-button
                        color="warn"
                        (click)="resetVirtualFence.emit()"
                        matTooltip="Undo changes"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  }
                }
                @if (!readonlyVirtualFence() && !isEmptyVirtualFence() && hasEmptyVirtualFence()) {
                  <div class="pt-6">
                    <div class="vf-left-sidebar-button-container">
                      <button
                        mat-button
                        (click)="onClickSetEmptyVirtualFence()"
                        matTooltip="Remove existing Fences from the collar"
                        [attr.data-testid]="'remove-empty-virtual-fence'"
                      >
                        <mat-icon color="warn">delete</mat-icon>
                        Remove Fences
                      </button>
                    </div>
                  </div>
                }
                @if (!allPolygons()?.length) {
                  @if (virtualFenceIds()?.length > 1) {
                    <div>
                      Different fences for selected <br />collars found! They are hidden <br />and
                      will be overwritten.
                    </div>
                  } @else if (!isEmptyVirtualFence()) {
                    <div class="text-wrapper font-bold">No fences found</div>
                  } @else if (isEmptyVirtualFence()) {
                    <div>This command removes the virtual fences on the device.</div>
                  }
                }
                @if (allPolygons()?.length) {
                  <div class="list-container">
                    <mat-list role="list">
                      @for (polygon of allPolygons(); track $index) {
                        <mat-list-item role="listitem">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              {{
                                polygon.name?.length > 8
                                  ? (polygon.name | slice: 0 : 8)
                                  : polygon.name
                              }}
                              @if (polygon.name?.length > 8) {
                                <span
                                  [matTooltip]="polygon.name"
                                  [matTooltipPosition]="'right'"
                                  [matTooltipDisabled]="!(polygon.name?.length > 8)"
                                  >...</span
                                >
                              }
                            </div>
                            <div class="pt-6 d-flex">
                              @if (currentlyEditingFenceId() === getUniqueId(polygon.insidePoint)) {
                                <mat-button-toggle-group
                                  appearance="standard"
                                  [hideSingleSelectionIndicator]="true"
                                  name="fontStyle"
                                  [(ngModel)]="polygon.isPointInside"
                                  (change)="onVirtualFencePointChanged($event, polygon.insidePoint)"
                                >
                                  <mat-button-toggle
                                    class="custom-toggle"
                                    matTooltip="select inside area"
                                    color="accent"
                                    [value]="true"
                                    >IN
                                  </mat-button-toggle>
                                  <mat-button-toggle
                                    class="custom-toggle"
                                    matTooltip="select outside area"
                                    color="accent"
                                    [value]="false"
                                    >OUT
                                  </mat-button-toggle>
                                </mat-button-toggle-group>
                                <mat-icon
                                  class="ml-6 mr-6"
                                  color="accent"
                                  (click)="saveEditedPolygon.emit(polygon.insidePoint)"
                                  >save
                                </mat-icon>
                              }

                              @if (
                                currentlyEditingFenceId() !== getUniqueId(polygon.insidePoint) &&
                                !isEditModeVirtualFence() &&
                                !readonlyVirtualFence() &&
                                enableVfButtons()
                              ) {
                                <mat-icon
                                  class="mr-6 icon"
                                  color="accent"
                                  (click)="
                                    onStartEditingPolygon(
                                      polygon.insidePoint,
                                      polygon.isPointInside
                                    )
                                  "
                                  >edit
                                </mat-icon>
                              }
                              @if (!isEditModeVirtualFence()) {
                                <mat-icon
                                  class="mr-6 icon"
                                  color="accent"
                                  (click)="setFocusOnPolygon.emit(polygon.insidePoint)"
                                  >gps_fixed
                                </mat-icon>
                                @if (!readonlyVirtualFence()) {
                                  <mat-icon
                                    class="mr-6 icon red"
                                    (click)="openDeleteDialog(polygon)"
                                    >close
                                  </mat-icon>
                                }
                              }
                            </div>
                          </div>
                        </mat-list-item>
                      }
                    </mat-list>
                  </div>
                }
              </div>
              <div class="pt-6">
                @if (!isEditModeVirtualFence() && !readonlyVirtualFence() && enableVfButtons()) {
                  @if (!drawHandlerVirtualFence()) {
                    <div class="d-flex">
                      <button
                        mat-button
                        color="accent"
                        class="w-50"
                        (click)="createNewPolygon.emit()"
                        matTooltip="Draw a new Virtual Fence"
                      >
                        Draw
                      </button>
                      <button
                        matTooltip="Upload a Virtual Fence kml-file"
                        mat-button
                        color="accent"
                        class="w-50"
                        (click)="openFilePicker()"
                      >
                        Upload
                      </button>
                      <input
                        type="file"
                        #fileInput
                        accept=".kml"
                        (change)="virtualFenceFileSelected.emit($event)"
                        style="display: none"
                        tabindex="-1"
                      />
                    </div>
                  } @else {
                    <button
                      mat-button
                      color="warn"
                      class="w-100"
                      (click)="cancelNewPolygonCreation.emit()"
                    >
                      cancel
                    </button>
                  }
                }
              </div>
            </div>
          </div>
        </vectronic-left-sidebar>
      } @else {
        <vectronic-left-sidebar
          [title]="'Devices'"
          class="left-sidebar"
          [class.left-sidebar--hidden]="mobileService.isOn()"
          (sidebarToggle)="mapService.onLeftSidebarToggle($event)"
        >
          <sm-shared-list-view
            [allDevices]="allDevices()"
            [mapPositions]="internalMapPositions()"
            (getPositionsForDevices)="prepareIdsForBECall($event)"
            (colorChanged)="colorChanged($event)"
            (clearMapPositionsEvent)="selectedCollarIds.set([])"
          ></sm-shared-list-view>
        </vectronic-left-sidebar>

        <!-- track animation feature -->
        @if (this.hasMapData() && !mobileService.isOn()) {
          <div
            class="d-flex flex-column p-absolute b-0"
            [ngClass]="isAnimationPlayActive() ? 'l-30' : 'l-50'"
          >
            @if (isAnimationPlayActive()) {
              <bm-trackplay
                [mapPositions]="internalMapPositions()"
                (isBottomMenuHidden)="isAnimationPlayActive.set($event)"
                [autoFocusEnabled]="shouldResetMapZoom()"
                (autoFocusToggled)="shouldResetMapZoom.set($event)"
                [speciesMap]="speciesMap()"
              ></bm-trackplay>
            } @else {
              <mat-card style="background: transparent">
                <mat-card-content class="time-slider-toggle">
                  <button
                    mat-button
                    class="btn-bg p-0 time-slider-toggle__button"
                    matTooltip="Show time slider"
                    (click)="isAnimationPlayActive.set(true)"
                  >
                    <mat-icon class="mr-0 play-icon" color="accent">{{ 'play_circle' }}</mat-icon>
                  </button>
                </mat-card-content>
              </mat-card>
            }
          </div>
        }
      }
    </div>
    <div [hidden]="isViewOnlyMode()">
      <bm-map-toolbar
        [userPreferences]="userPreferences()"
        [filtersToDisplay]="filtersToDisplay()"
        [pageName]="pageName()"
        [hideSettingsBtn]="hideSettingsBtn()"
        [initialLastXRecordsValue]="initialLastXRecordsValue()"
        (filterValuesSaved)="mapFilterService.onFilterChanged($event)"
        [autoFocusEnabled]="shouldResetMapZoom()"
        (autoFocusToggled)="shouldResetMapZoom.set($event)"
        [selectedCollarIds]="selectedCollarIds()"
        (selectedCollarsFilterListChange)="onSelectedCollarsFilterListChange($event)"
        (virtualFenceZoomToCollar)="setMapPositionAndZoom($event)"
        [isVirtualFenceEnabled]="isVirtualFenceEnabled()"
      ></bm-map-toolbar>
    </div>
  }
</div>
